const DINGTALK_MAGIC_ORB_SRC =
  process.env.VUE_APP_DINGTALK_MAGIC_ORB_URL ||
  'https://g.alicdn.com/gdt/deap_floating_ball/0.0.2/index.mjs'
const DINGTALK_STYLE_ID = 'dingtalk-copilot-override-style'
const ORB_ICON = 'https://www.tengen.com/public/static/modules/cms/img/ai_tg.gif'
const ORB_ICON_HOVER = 'https://www.tengen.com/public/static/modules/cms/img/ai_tg_wave.png'

let injecting = false

function bindOrbHover() {
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const tryBind = () => {
    const orb = document.querySelector('.dingtalk-open-copilot-container')
    if (!orb || orb.dataset.tzBound) return false
    const icon = orb.querySelector(':scope > div')
    if (!icon) return false
    orb.dataset.tzBound = '1'
    icon.style.setProperty('background-size', 'contain', 'important')
    icon.style.setProperty('background-repeat', 'no-repeat', 'important')
    icon.style.setProperty('background-position', 'center bottom', 'important')
    if (isMobile) return true
    orb.addEventListener('mouseenter', () => {
      orb.classList.add('is-hover')
      icon.style.setProperty('background-image', `url("${ORB_ICON_HOVER}")`, 'important')
    })
    orb.addEventListener('mouseleave', () => {
      orb.classList.remove('is-hover')
      icon.style.setProperty('background-image', `url("${ORB_ICON}")`, 'important')
    })
    return true
  }
  if (tryBind()) return
  const timer = setInterval(() => {
    if (tryBind()) clearInterval(timer)
  }, 300)
  setTimeout(() => clearInterval(timer), 15000)
}

function bindMobileDock() {
  const mq = window.matchMedia('(max-width: 768px)')
  const tryBind = () => {
    const orb = document.querySelector('.dingtalk-open-copilot-container')
    if (!orb || orb.dataset.tzMobileBound) return false
    if (!mq.matches) return false
    orb.dataset.tzMobileBound = '1'
    orb.classList.add('tz-mobile-dock', 'is-collapsed')
    orb.addEventListener('click', (e) => {
      if (orb.classList.contains('is-collapsed')) {
        e.preventDefault()
        e.stopPropagation()
        orb.classList.remove('is-collapsed')
        orb.classList.add('is-expanded')
      }
    }, true)
    document.addEventListener('click', (e) => {
      if (!orb.contains(e.target)) {
        orb.classList.add('is-collapsed')
        orb.classList.remove('is-expanded')
      }
    })
    return true
  }
  if (tryBind()) return
  const timer = setInterval(() => {
    if (tryBind()) clearInterval(timer)
  }, 300)
  setTimeout(() => clearInterval(timer), 15000)
}

function addOrbStyle() {
  if (document.getElementById(DINGTALK_STYLE_ID)) return
  const style = document.createElement('style')
  style.id = DINGTALK_STYLE_ID
  style.textContent = `
    .dingtalk-open-copilot-container {
      top: 62% !important;
      left: auto !important;
      right: 20px !important;
      bottom: auto !important;
      transform: translateY(-50%) !important;
      z-index: 99999 !important;
      width: 120px !important;
      height: 163px !important;
      border-radius: 0 !important;
      overflow: visible !important;
      background: transparent !important;
      box-shadow: none !important;
    }
    .dingtalk-open-copilot-container > div {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0 !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center bottom !important;
      background-color: transparent !important;
    }
    .dingtalk-open-copilot-container::before {
      content: 'Hi,我是AI小助手！点我！\\A可快速为您查询产品资料哦！';
      white-space: pre;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, calc(-100% + 40px));
      padding: 10px 16px;
      border-radius: 12px;
      background: linear-gradient(90deg, #9ef0d8 0%, #7fd8f5 100%);
      color: #111;
      font-size: 12px;
      line-height: 1.55;
      font-weight: 500;
      text-align: center;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
      width: max-content;
      max-width: 260px;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: opacity 0.2s ease, visibility 0.2s;
      z-index: 10;
    }
    .dingtalk-open-copilot-container::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, 40px);
      border: 6px solid transparent;
      border-top-color: #8ae4e8;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: opacity 0.2s ease, visibility 0.2s;
      z-index: 10;
    }
    .dingtalk-open-copilot-container.is-hover::before,
    .dingtalk-open-copilot-container.is-hover::after {
      opacity: 1;
      visibility: visible;
    }
    @media (max-width: 768px) {
      .dingtalk-open-copilot-container {
        width: 72px !important;
        height: 98px !important;
        top: 70% !important;
        right: 0 !important;
        transition: transform 0.25s ease, right 0.25s ease !important;
      }
      .dingtalk-open-copilot-container.tz-mobile-dock.is-collapsed {
        transform: translate(58%, -50%) !important;
      }
      .dingtalk-open-copilot-container.tz-mobile-dock.is-expanded {
        right: 8px !important;
        transform: translate(0, -50%) !important;
      }
      .dingtalk-open-copilot-container::before,
      .dingtalk-open-copilot-container::after,
      .dingtalk-open-copilot-container.is-hover::before,
      .dingtalk-open-copilot-container.is-hover::after {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }
    }
  `
  document.head.appendChild(style)
}

export function injectDingtalkMagicOrb() {
  if (injecting || document.querySelector('script[data-dingtalk-magic-orb]')) {
    return
  }
  injecting = true
  window.dingtalkAgentConfig = {
    code: '1e8a5f72-99e1-4e8f-9715-21054440eeab',
    h5Domain: 'https://deap-agent.dingtalk.com/deapHttpProxy/chat',
    accountToken: '',
    extraRef: '',
    orbIcon: ORB_ICON,
    orbSize: '120px',
    orbRadius: '0'
  }
  addOrbStyle()
  const script = document.createElement('script')
  script.type = 'module'
  script.src = DINGTALK_MAGIC_ORB_SRC
  script.setAttribute('data-dingtalk-magic-orb', '')
  document.body.appendChild(script)
  bindOrbHover()
  bindMobileDock()
}
